import "./index.scss";
import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import FilterBar from '../FilterBar';
import AccordionItem from './AccordionItem';

export default function Accordion({ component }) {
  const [filters, setFilters] = useState([]);
  const [selectFiltersValues, setSelectFiltersValues] = useState([]);

  // = = = = = = = = = = = = =
  // GraphQL
  const accordionData = useStaticQuery(graphql`
    query accordionData {
      jobs: allDatoCmsJob {
        nodes {
          datePosted(formatString: "MMMM DD YYYY")
          description
          organization
          slug
          role
          title
          typeOfPosition
        }
      }
    }  
  `);

  const { showFilterBar, contentFilter } = component;

  const data = accordionData.jobs.nodes;
  
  const [showContent, setShowContent] = useState(null);


  // = = = = = = = = = = = = =
  // Hooks

  useEffect(() => {

    // const selectInputsValues = contentFilter[0].selectInputs.map(object => (
    //   {
    //     [object.inputLabel]: data.map(item => item[object.property])
    //   }
    // ));

    const selectInputsValues = contentFilter[0].selectInputs.map(object => (
      {
        id: object.property,
        label: object.inputLabel,
        values: data.map(item => item[object.property])
      }
    ));

    setSelectFiltersValues(selectInputsValues);
  }, [])


  // = = = = = = = = 
  // Event Handlers

  const toggleOpen = id => () => setShowContent(
    showContent => showContent === id ? null : id,
  );

  const filterData = (e) => {
    e.preventDefault();
    const filteredData= data.filter(item => {
      filters.forEach(filter => {
        for (let key in filter) {
          if (item[key] === undefined || item[key] != filter[key]) {
            return false;
          }
          return item;
        }
      })
    });

    console.log(filteredData)

  }

  return (
    <>
      {
        showFilterBar 
          && 
        <FilterBar 
          filtersValues={selectFiltersValues} 
          component={contentFilter[0]}
          filters={filters}
          setFilters={setFilters}
          filterData={filterData}
        />
      }
      <section className="accordion-section">
        <div className="container">
          <div className="row">

            <div className="col-md-10">

              <div className="accordion" id="accordion">
                {
                  data.map(({ description, title, datePosted, organization, slug },  index) => (
                    <AccordionItem 
                      key={index}
                      index={index}
                      hiddenContent={description}
                      visibleContent={title}
                      showContent={showContent === index}
                      datePosted={datePosted}
                      organization={organization}
                      slug={slug}
                      toggle={toggleOpen(index)}
                    />
                  ))
                }
              </div>

            </div>

          </div>
        </div>
      </section>
    </>
  )
}